// import React from "react";
// import { Box } from "@mui/material";
// import ReactECharts from "echarts-for-react";

// const GaugeChartComponent = ({
//   value = 0,
//   name,
//   otherValue = 10,
//   height = "230px",
// }) => {
//   const option = {
//     series: [
//       {
//         type: "gauge",
//         detail: {
//           formatter: "{value}",
//           fontSize: 20,
//           color: "black",
//         },
//         title: {
//           show: true,
//           fontSize: 14,
//           color: "black",
//           offsetCenter: [0, "100%"],
//         },
//         data: [
//           {
//             value,
//             name,
//           },
//           // {
//           //   value: otherValue,
//           // },
//         ],
//         axisLine: {
//           roundCap: true,
//           lineStyle: {
//             color: [
//               [0.25, "#D56626"],
//               [0.5, "#E5A37D"],
//               [0.75, "#E8D0B1"],
//               [1, "#7CAB53"],
//             ],
//             width: 10,
//           },
//         },
//         axisTick: {
//           show: false,
//         },
//         axisLabel: {
//           show: false,
//         },
//         splitLine: {
//           show: true,
//         },
//         pointer: {
//           length: "65%",
//           width: 3,
//         },
//         itemStyle: {
//           color: "black",
//         },
//       },
//     ],
//   };

//   return (
//     <>
//       <ReactECharts option={option} style={{ height, width: "300px" }} />
//     </>
//   );
// };

// export default GaugeChartComponent;

import React from "react";
import ReactECharts from "echarts-for-react";
import { range } from "lodash";

const GaugeChartComponent = ({
  value = 0,
  name,
  otherValue = 10,
  height = "230px",
  width = "100%",
  range = [],
}) => {
  const maxValue = Math.max(...range.map((r) => r.max), 100);
  const colorStops = range.map((r) => [r.max / maxValue, r.color]);

  const option = {
    series: [
      {
        type: "gauge",
        detail: {
          formatter: "{value}",
          fontSize: 20,
          color: "black",
        },
        title: {
          show: true,
          fontSize: 14,
          color: "black",
          offsetCenter: [0, "100%"],
        },
        data: [
          {
            value,
            name,
          },
        ],
        axisLine: {
          roundCap: true,
          lineStyle: {
            color: colorStops,
            width: 12,
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: true,
        },
        pointer: {
          length: "65%",
          width: 7,
        },
        itemStyle: {
          color: "#B29263",
        },
        animation: false,
        animationDuration: 0,
        animationDurationUpdate: 0,
      },

      {
        type: "gauge",
        radius: "100%",
        pointer: {
          show: true,
          length: "60%",
          width: 2,
        },
        itemStyle: {
          color: "#000",
        },
        detail: {
          show: false,
        },
        data: [
          {
            value: otherValue,
          },
        ],
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        progress: {
          show: false,
        },
        animation: false,
        animationDuration: 0,
        animationDurationUpdate: 0,
      },
    ],
  };

  return <ReactECharts option={option} style={{ height, width }} />;
};

export default GaugeChartComponent;
